import gql from 'graphql-tag';

import mainDisplayObjectFragment from './mainDisplayObjectFragment';

export const recentlyEditedMainDisplayObjectFragment = gql`
  fragment recentlyEditedMainDisplayObjectFragment on RecentlyEditedMainDisplayObject {
    dokkioClass
    mainDisplayObject {
      ...mainDisplayObjectFragment
    }
    lastEditedAt
  }
  ${mainDisplayObjectFragment}
`;
export default recentlyEditedMainDisplayObjectFragment;
